import { useQuery } from '@tanstack/react-query';
import { membershipApi, MembershipSummaryParams } from '../api/membership';
import { MembershipSummaryDto } from '../types';

export function useMembershipData(params?: MembershipSummaryParams) {
  return useQuery<MembershipSummaryDto, Error>({
    queryKey: ['membership-summary', params?.company, params?.brgId],
    queryFn: () => membershipApi.getSummary(params),
  });
}
